<template>
    <el-checkbox-group v-if="question.isCheckBoxList" v-model="selected">
        <el-checkbox
            v-for="item in items"
            :id="item.id + '_cdt'"
            :label="item.cd_key"
            :key="item.cd_key"
            >{{ item.cd_value ? item.cd_value.trim() : '' }}</el-checkbox
        >
    </el-checkbox-group>
    <div v-else-if="question.isComboBox || question.isNathanType" class="w-100">
        <el-radio-group v-model="selected">
            <el-radio
                v-for="item in items"
                :id="item.id + '_cdt'"
                :label="item.cd_key"
                :key="item.cd_key"
                @click.native="uncheck(item.cd_key)"
                change="uncheck"
                >{{ item.cd_value }}</el-radio
            >
        </el-radio-group>
        <el-input
            v-if="!question.isNathanType && otherTextVisible"
            v-model="question.data.other_value"
            size="small"
            type="text"
        ></el-input>
    </div>
    <div v-else-if="question.isNCBListType" class="ncb-container">
        <div>
            <el-select
                ref="combobox"
                clearable
                v-model="selected"
                popper-class="combobox-popper"
                filterable
                :placeholder="$t('Select one')"
                class="w-75"
                size="small"
                @visible-change="onPopperVisible"
                :remote="question.is_lazy_loaded"
                :remote-method="question.is_lazy_loaded ? onComboboxFilter : null"
                :loading="controlDataLoading"
            >
                <el-option
                    v-for="item in items"
                    :id="item.id + '_cdt'"
                    :key="item.cd_key"
                    :label="item.cd_value"
                    :value="item.cd_key"
                    :title="item.cd_value"
                ></el-option>
            </el-select>
            <el-button
                size="small"
                v-if="allowCreate"
                icon="el-icon-plus"
                @click="addNewOptionVisible = true"
            ></el-button>
        </div>
        <el-dialog :visible.sync="addNewOptionVisible" v-if="allowCreate" :loading="optionSaving">
            <el-input
                v-model="formQuestionControlData.cd_value"
                :placeholder="$t('New Option')"
                class="mt-10px"
            ></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="saveOption" type="primary" size="small">{{
                    $t('Save & Close')
                }}</el-button>
                <el-button type="text" @click="addNewOptionVisible = false" size="small">{{
                    $t('Close')
                }}</el-button>
            </div>
        </el-dialog>
    </div>
    <div v-else-if="question.isComboBoxAsCombo" class="w-100">
        <el-select
            class="w-100"
            ref="combobox"
            v-model="selected"
            popper-class="combobox-popper"
            filterable
            size="small"
            :placeholder="$t('Select one')"
            @visible-change="onPopperVisible"
        >
            <el-option
                v-for="item in items"
                :id="item.id + '_cdt'"
                :key="item.cd_key"
                :label="item.cd_value"
                :value="item.cd_key"
                :title="item.cd_value"
            ></el-option>
        </el-select>
        <el-input
            v-if="otherTextVisible"
            v-model="question.data.other_value"
            size="small"
            type="text"
        ></el-input>
    </div>
    <div v-else-if="question.isSICComponent" class="w-100">
        <el-cascader
            v-model="selected"
            :options="selectedRootIndustryClassificationList"
            :props="cascaderProps"
            :show-all-levels="false"
            :placeholder="$t('Please select')"
            :filterable="true"
            :filter-method="onIndustryClassificationFilter"
            class="w-100"
            popper-class="industry-classification"
            size="small"
            clearable
        ></el-cascader>
    </div>
</template>

<script>
import eventBus from '@app/src/lib/helpers/eventbus';
import FormQuestion from '@/data/FormQuestion';
import FormQuestionControlData from '@/data/FormQuestionControlData';

export default {
    name: 'selection',
    props: {
        question: {
            type: FormQuestion,
            required: true,
        },
        section: { type: Object, required: false },
        ruleparser: null,
    },
    data() {
        return {
            addNewOptionVisible: false,
            selected: [],
            previouslySelected: null,
            formQuestionControlData: new FormQuestionControlData(),
            optionSaving: false,
            controlDataLoading: false,
            otherTextVisible: false,
            cascaderProps: {
                emitPath: false,
            },
        };
    },
    computed: {
        industryClassificationList() {
            return this.$store.getters.industryClassificationList;
        },
        selectedIndustryClassificationList() {
            return this.industryClassificationList.filter((item) => item.type === 'SIC'); // : [];
        },
        selectedRootIndustryClassificationList() {
            return this.getChildIndustryClassifications(null);
        },
        multiple() {
            return this.question.isCheckBoxList;
        },
        items() {
            // 2 if you want to sort by cd_value
            if (this.question.sort_by === 2) {
                const data = this.question.control_data || [];
                return data.sort((a, b) => a.cd_value.localeCompare(b.cd_value));
                // 1 if you want to order by "order" field
            }
            return this.question.control_data || [];
        },
        allowCreate() {
            return this.question.allowCreate;
        },
    },
    mounted() {
        if (!this.industryClassificationList.loaded) {
            this.industryClassificationList.load();
        }

        for (let i = 0, l = this.items && this.items.length; i < l; i += 1) {
            const item = this.items[i];

            const $item = document.getElementById(`${item.id}_cdt`);

            if ($item) {
                $item.style.setProperty(
                    'display',
                    item.default_visibility ? 'block' : 'none',
                    'important'
                );
            }
        }

        // secenegin gosterilmemesi durumunda secenek isaretlenmisse cevaptan kaldir.
        eventBus.$on('optionHided', (message) => {
            const selection = this.question.control_data.find((item) => item.id == message.ref_id);

            if (!selection) {
                return;
            }

            if (this.multiple) {
                const index = this.selected.indexOf(selection.cd_key);

                if (index > -1) {
                    this.selected.splice(this.selected.indexOf(selection.cd_key), 1);
                }
            } else if (this.selected == selection.cd_key) {
                this.selected = '';
            }
        });

        for (let i = 0, l = this.items && this.items.length; i < l; i += 1) {
            const item = this.items[i];
            const $item = document.getElementById(`${item.id}_cdt`);

            if ($item) {
                $item.style.setProperty(
                    'display',
                    item.default_visibility ? 'block' : 'none',
                    'important'
                );
            }
        }
        this.fillSelected();
        if (this.question.data.return_value) {
            this.onComboboxChange(this.question.data.return_value);
        }
    },
    watch: {
        addNewOptionVisible(value) {
            if (value) {
                this.formQuestionControlData = new FormQuestionControlData();
            }
        },
        'question.data.return_value': function (val, oldVal) {
            this.fillSelected();
            if (val != oldVal) {
                this.onComboboxChange(val);
            }
        },
        selected: {
            handler(v, oldVal) {
                if (this.question.isSICComponent) {
                    this.question.data.return_value = v;
                    return;
                }
                this.previouslySelected = oldVal;

                if (this.multiple) {
                    const selected = [].concat(v);
                    selected.sort();
                    this.question.data.return_value = selected
                        .map((key) => key.replace(/,/gi, ''))
                        .join(',');
                } else {
                    this.question.data.return_value = v || (this.question.isCheckBoxList ? [] : v);
                }

                if (this.multiple) {
                    const cdPreArray = this.previouslySelected;
                    const cdSelArray = v || [];
                    const differenceCan = cdPreArray.filter((x) => !cdSelArray.includes(x));
                    const differenceApply = cdSelArray.filter((x) => !cdPreArray.includes(x));

                    for (let i = 0, l = differenceCan && differenceCan.length; i < l; i += 1) {
                        // previouslySelected a ait rule varsa tersini calistir.
                        // secilenin cdt id sini al
                        const cdPre = this.question.control_data.find(
                            (cd) => cd.cd_key == differenceCan[i]
                        );
                        // cdt id ye ait rulelari al
                        if (cdPre && cdPre.id) {
                            const rulesPre = cdPre.rules;

                            // ve islemi geri al
                            this.ruleparser.ruleParserNew(rulesPre, { id: cdPre.id }, true);
                        }
                    }

                    for (let i = 0, l = differenceApply && differenceApply.length; i < l; i += 1) {
                        // run rule
                        const cd = this.question.control_data.find(
                            (data) => data.cd_key == differenceApply[i]
                        );
                        if (cd && cd.id) {
                            const { rules } = cd;
                            this.ruleparser.ruleParserNew(rules, {
                                id: cd.id,
                            });
                        }
                    }
                } else {
                    // previouslySelected a ait rule varsa tersini calistir.
                    // secilenin cdt id sini al
                    const cdPre = this.question.control_data.filter(
                        (cd) => cd.cd_key == this.previouslySelected
                    )[0];
                    // cdt id ye ait rulelari al
                    if (cdPre && cdPre.id) {
                        const rulesPre = cdPre.rules;

                        // ve islemi geri al
                        this.ruleparser.ruleParserNew(rulesPre, { id: cdPre.id }, true);
                    }
                    // run rule
                    const cd = this.question.control_data.find((data) => data.cd_key == v);

                    const { id, rules } = cd || {};

                    if (id && rules) {
                        this.ruleparser.ruleParserNew(rules, {
                            id,
                        });
                    }

                    this.otherTextVisible = cd ? cd.is_other_value : false;
                }
            },
        },
    },
    methods: {
        onIndustryClassificationFilter(node, keyword) {
            return node.label.toLowerCase().indexOf(keyword.toLowerCase()) > -1;
        },
        getChildIndustryClassifications(id) {
            return this.selectedIndustryClassificationList
                .filter((item) => item.parent_id === id)
                .map((item) => {
                    const children = this.getChildIndustryClassifications(item.id);

                    return {
                        value: item.id,
                        label: `${item.code} - ${item.name}`,
                        leaf: children.length === 0,
                        children: children.length === 0 ? null : children,
                    };
                });
        },
        uncheck(val) {
            if (val === this.previouslySelected) {
                this.selected = null;
            }
            this.previouslySelected = this.selected;
        },
        fillSelected() {
            if (this.multiple) {
                const selection = this.question.data.return_value
                    ? this.question.data.return_value.split(',')
                    : [];
                this.selected = this.question.control_data
                    .filter((item) => selection.indexOf(item.cd_key.replace(/,/gi, '')) > -1)
                    .map((item) => item.cd_key);
            } else {
                this.selected = this.question.data.return_value;
            }

            if (
                // this.question.isNCBUNID &&
                this.question.is_lazy_loaded &&
                this.question.data.return_value &&
                this.question.data.display_value
            ) {
                this.getControlDataOfValue();
            }
        },
        onPopperVisible(visible) {
            if (visible) {
                this.$refs.combobox.popperElm.style.width = `${this.$refs.combobox.$el.offsetWidth}px`;
            }
        },
        saveOption() {
            this.formQuestionControlData.save({
                params: {
                    option: this.formQuestionControlData.cd_value,
                    form_ques_id: this.question.id,
                },
                beforesend: () => {
                    this.optionSaving = true;
                },
                complete: () => {
                    this.optionSaving = false;
                },
                success: () => {
                    this.question.control_data.add(this.formQuestionControlData);
                    this.selected = this.formQuestionControlData.cd_key;
                    this.addNewOptionVisible = false;
                },
            });
        },
        onComboboxChange(value) {
            if (this.question.isNCBUNID) {
                const psnQuestion = this.findQuestionByCaption('PSN');
                const classQuestion = this.findQuestionByCaption('Class / Subrisk');
                const pgQuestion = this.findQuestionByCaption('PG');
                const descriptionsQuestion = this.findQuestionByCaption('Descriptions');
                const dataMap = [
                    'VARIANT',
                    'LABELS49',
                    'PACKGRP49',
                    'FP',
                    'QDT',
                    'QDT49',
                    'EMS',
                    'MP',
                    'MP49',
                    'TECHNAME',
                    'PIH49',
                ];
                const descr = [];

                psnQuestion.data.return_value = null;
                classQuestion.data.return_value = null;
                pgQuestion.data.return_value = null;
                descriptionsQuestion.data.return_value = null;

                if (!value) {
                    return;
                }

                this.question.getUNIDInfo({
                    params: {
                        key: value,
                    },
                    beforesend: () => {
                        this.unidLoading = true;
                    },
                    complete: () => {
                        this.unidLoading = false;
                    },
                    success: (op, response, data) => {
                        psnQuestion.data.return_value = data.PSN;
                        classQuestion.data.return_value = data.CLASS;
                        pgQuestion.data.return_value = data.PG;

                        dataMap.forEach((item) => {
                            if (data[item]) {
                                descr.push(`${item}: ${data[item]}`);
                            }
                        });

                        descriptionsQuestion.data.return_value = descr.join('\n');
                    },
                });
            }
        },
        findQuestionByCaption(caption) {
            let question = null;

            if (this.section) {
                this.section.questions.some((item) => {
                    if (item.caption.toLowerCase().trim() == caption.toLowerCase().trim()) {
                        question = item;
                        return true;
                    }

                    return false;
                });
            }

            return question;
        },
        onComboboxFilter(query) {
            if (!query || query.length >= 3) {
                this.question.getControlDataList({
                    params: {
                        query,
                        id: this.question.id,
                    },
                    beforesend: () => {
                        this.controlDataLoading = true;
                    },
                    complete: () => {
                        this.controlDataLoading = false;
                    },
                    success: (op, response, data) => {
                        this.question.control_data = data;
                    },
                });
            }
        },
        getControlDataOfValue() {
            if (
                !this.question.control_data.find(
                    (item) => item.cd_key == this.question.data.return_value
                )
            ) {
                this.question.control_data.add({
                    cd_key: this.question.data.return_value,
                    cd_value: this.question.data.display_value,
                });
            }
            /*
            this.question.getControlData({
                params: {
                    key: this.question.data.return_value,
                    id: this.question.id,
                },
                beforesend: () => {
                    this.controlDataLoading = true;
                },
                complete: () => {
                    this.controlDataLoading = false;
                },
                success: (op, response, data) => {
                    this.question.control_data = data;
                },
            });
            */
        },
    },
};
</script>

<style lang="scss">
.el-radio__label {
    white-space: pre-wrap;
    display: inline-block;
    vertical-align: text-top;
    line-height: 19px;
}
.el-checkbox,
.el-radio {
    margin-bottom: 10px;
}
.el-tree-node__content {
    .el-checkbox,
    .el-radio {
        margin-bottom: 0px;
    }
}
.el-checkbox__label {
    white-space: pre-wrap;
    vertical-align: text-top;
}
.el-radio__input,
.el-checkbox__input {
    height: 19px;
    display: inline-flex;
    align-items: center;
    vertical-align: text-top;
}
</style>
